/* eslint-disable */
import moment from "moment";
import Swal from "sweetalert2";
import toastr from "toastr";
import "toastr/build/toastr.css";
import _ from "underscore";
var jwtDecode = require("jwt-decode");

export function copyToClipboard(it) {
    var copyText = document.getElementById(it);
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */
    navigator.clipboard.writeText(copyText.value);
    toastr.info("Link copied to clipboard", "Share url");
}

export function getDaysOfMonth(year, month) {
    var monthDate = moment(year + "-" + month, "YYYY-MM");
    var daysInMonth = monthDate.daysInMonth();
    var arrDays = [];
    while (daysInMonth) {
        var current = moment().date(daysInMonth);
        arrDays.push(current);
        daysInMonth--;
    }
    return arrDays;
}

export function getMonthsOfYear(selectedYear) {
    let timeValues = [
        moment(selectedYear + "-01-01", "YYYY-MM-DD"),
        moment(selectedYear + "-02-01", "YYYY-MM-DD"),
        moment(selectedYear + "-03-01", "YYYY-MM-DD"),
        moment(selectedYear + "-04-01", "YYYY-MM-DD"),
        moment(selectedYear + "-05-01", "YYYY-MM-DD"),
        moment(selectedYear + "-06-01", "YYYY-MM-DD"),
        moment(selectedYear + "-07-01", "YYYY-MM-DD"),
        moment(selectedYear + "-08-01", "YYYY-MM-DD"),
        moment(selectedYear + "-09-01", "YYYY-MM-DD"),
        moment(selectedYear + "-10-01", "YYYY-MM-DD"),
        moment(selectedYear + "-11-01", "YYYY-MM-DD"),
        moment(selectedYear + "-12-01", "YYYY-MM-DD"),
    ];
    return timeValues.reverse();
}

export function getLastFiveYear() {
    let timeValues = [
        moment().subtract(4, "year"),
        moment().subtract(3, "year"),
        moment().subtract(2, "year"),
        moment().subtract(1, "year"),
        moment(),
    ];
    return timeValues.reverse();
}

export function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
}

export function getHeaderDetail(headerInfo = {}) {
    let headers = {
        Accept: "application/json",
        "Content-Type": "application/json",

        "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE,PATCH",
        Authorization: "Bearer " + getToken(),
    };
    headers = { ...headers, ...headerInfo };

    return headers;
}

export function geocodeResponseToCityState(geocodeJSON) {
    //will return and array of matching {city,state} objects
    var parsedLocalities = [];
    if (geocodeJSON.results.length) {
        for (var i = 0; i < geocodeJSON.results.length; i++) {
            var result = geocodeJSON.results[i];

            var locality = {};
            for (var j = 0; j < result.address_components.length; j++) {
                var types = result.address_components[j].types;
                for (var k = 0; k < types.length; k++) {
                    if (types[k] === "locality") {
                        locality.city = result.address_components[j].long_name;
                    } else if (types[k] === "administrative_area_level_1") {
                        locality.state =
                            result.address_components[j].short_name;
                    }
                }
            }
            parsedLocalities.push(locality);

            //check for additional cities within this zip code
            if (result.postcode_localities) {
                for (var l = 0; l < result.postcode_localities.length; l++) {
                    parsedLocalities.push({
                        city: result.postcode_localities[l],
                        state: locality.state,
                    });
                }
            }
        }
    } else {
        console.log("error: no address components found");
    }
    return parsedLocalities;
}

export function carouselSettingsMobile() {
    return {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
    };
}

export function carouselSettings() {
    return {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
    };
}

export function IsNullOrEmpty(name) {
    return name === "" || name === undefined || name === null;
}

export function base64toBlob(base64Image) {
    // Split into two parts
    const parts = base64Image.split(';base64,');

    // Hold the content type
    const imageType = parts[0].split(':')[1];

    // Decode Base64 string
    const decodedData = window.atob(parts[1]);

    // Create UNIT8ARRAY of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);

    // Insert all character code into uInt8Array
    for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i);
    }

    // Return BLOB image after conversion
    return new Blob([uInt8Array], { type: imageType });
}

export async function toDataURL(url) {
    const blob = await fetch(url).then(res => res.blob());
    return URL.createObjectURL(blob);
}

export function hexToRGB(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
    }
}

export function validURL(str) {
    var pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
        "i"
    ); // fragment locator
    return !IsNullOrEmpty(str) && !!pattern.test(str);
}

export function validEmail(email) {
    const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !IsNullOrEmpty(email) && re.test(String(email).toLowerCase());
}

export function validPassword(password) {
    const pa = new RegExp(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&.])[A-Za-z\d$@$!%*?&.]{8,}/
    );
    return !IsNullOrEmpty(password) && pa.test(password);
}

export function validUsername(username) {
    const us = new RegExp(/^(?=.*[\S])[a-zA-Z0-9]{6,30}$/);
    return !IsNullOrEmpty(username) && us.test(username);
}

export function validPhone(phone) {
    return !IsNullOrEmpty(phone) && phone.length < 11 && phone.length > 6;
}

export const arrayToObject = (array) =>
    array.reduce((obj, item) => {
        obj[item.name] =
            item.type === "FileDrop" || item.type === "Chip"
                ? []
                : item.defaultValue;
        return obj;
    }, {});

export const replaceLocalSrcTags = (input, localSrc, src) => {
    return input.replace(localSrc, src);

    // if ( images ) {
    //     for ( let uploadedImage of images ) {
    //         input = input.replace( uploadedImage.localSrc, uploadedImage.file.name );
    //     }

    //     return input;
    // }
    // else {
    //     return '';
    // }
};

export function decodeToken() {
    let token = getToken();
    try {
        if (token !== null && token !== undefined && token !== "")
            return jwtDecode(token);
        else return null;
    } catch (e) {
        return null;
    }
}

export function isTokenValid() {
    let token = getToken();
    let isAuthenticated = false;
    try {
        isAuthenticated = !IsNullOrEmpty(token);
        if (isAuthenticated) {
            var decoded = decodeToken();
            isAuthenticated = moment.unix(decoded.exp).isAfter(moment());
        }
    } catch (e) {
        isAuthenticated = false;
    }

    return isAuthenticated;
}

export function clearToken() {

    sessionStorage.removeItem(process.env.REACT_APP_AUTH_TOKEN);
    sessionStorage.removeItem("persist:ulalive");
}

export function getToken() {
    return sessionStorage.getItem(process.env.REACT_APP_AUTH_TOKEN);
}

export function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            var r = (Math.random() * 16) | 0,
                v = c === "x" ? r : r & (0x3 | 0x8);
            return v.toString(16);
        }
    );
}

export function camelize(str) {
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, "");
}

export function convertToSlug(Text) {
    return Text.toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
}

export function letterValue(str) {
    if (!str) {
        return "";
    }
    str = str.toLowerCase();
    var anum = {
        a: 32,
        b: 29,
        c: 27,
        d: 4,
        e: 5,
        f: 6,
        g: 7,
        h: 8,
        i: 9,
        j: 10,
        k: 11,
        l: 12,
        m: 13,
        n: 14,
        o: 15,
        p: 16,
        q: 17,
        r: 18,
        s: 19,
        t: 20,
        u: 21,
        v: 22,
        w: 23,
        x: 24,
        y: 25,
        z: 26,
    };

    let newStr = Array.from(str).map((x) => {
        return anum[x] || x;
    });
    return newStr.join("");
}

export function nFormatter(num, digits) {
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
        .slice()
        .reverse()
        .find(function (item) {
            return num >= item.value;
        });
    return item
        ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
        : "0";
}

export function numberWithCommas(x) {
    return x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function slugify(string) {
    return string
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w\-]+/g, "")
        .replace(/\-\-+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");
}

export function getRandomColor() {
    return [
        "rgb(207, 201, 232)",
        "rgb(246, 238, 225)",
        "rgb(246, 243, 249)",
        "rgb(237, 248, 206)",
        "rgb(208, 238, 202)",
        "rgb(252, 202, 239)",
        "rgb(228, 227, 237)",
        "rgb(242, 252, 218)",
        "rgb(202, 245, 247)",
        "rgb(249, 218, 239)",
        "rgb(233, 211, 252)",
        "rgb(218, 244, 237)",
        "rgb(228, 218, 225)",
        "rgb(235, 216, 229)",
        "rgb(242, 215, 211)",
        "rgb(208, 205, 241)",
        "rgb(253, 222, 233)",
        "rgb(206, 208, 223)",
        "rgb(208, 205, 228)",
        "rgb(228, 219, 220)",
        "rgb(217, 237, 224)",
        "rgb(213, 239, 233)",
        "rgb(200, 227, 249)",
        "rgb(230, 215, 223)",
        "rgb(255, 215, 221)",
        "rgb(215, 239, 214)",
        "rgb(231, 227, 229)",
        "rgb(216, 241, 234)",
        "rgb(214, 251, 244)",
        "rgb(214, 213, 203)",
        "rgb(214, 211, 224)",
        "rgb(216, 200, 219)",
        "rgb(246, 245, 212)",
        "rgb(231, 222, 216)",
        "rgb(240, 225, 225)",
        "rgb(247, 209, 244)",
        "rgb(230, 213, 230)",
        "rgb(228, 219, 200)",
        "rgb(214, 250, 206)",
        "rgb(249, 232, 243)",
        "rgb(214, 255, 254)",
        "rgb(204, 236, 231)",
        "rgb(204, 243, 255)",
        "rgb(254, 216, 211)",
        "rgb(242, 237, 225)",
        "rgb(236, 232, 224)",
        "rgb(239, 215, 219)",
        "rgb(207, 230, 208)",
        "rgb(204, 228, 243)",
        "rgb(238, 210, 208)",
        "rgb(242, 245, 208)",
        "rgb(207, 243, 254)",
        "rgb(210, 201, 229)",
        "rgb(255, 254, 201)",
        "rgb(245, 255, 236)",
        "rgb(227, 217, 200)",
        "rgb(247, 246, 229)",
        "rgb(242, 209, 222)",
        "rgb(230, 232, 255)",
        "rgb(226, 217, 200)",
        "rgb(249, 222, 236)",
        "rgb(203, 222, 247)",
        "rgb(219, 254, 246)",
        "rgb(214, 201, 202)",
        "rgb(205, 222, 220)",
        "rgb(208, 248, 241)",
        "rgb(223, 231, 214)",
        "rgb(253, 225, 246)",
        "rgb(255, 213, 241)",
        "rgb(255, 254, 241)",
        "rgb(212, 209, 203)",
        "rgb(214, 240, 248)",
        "rgb(247, 211, 234)",
        "rgb(246, 211, 251)",
        "rgb(224, 216, 240)",
        "rgb(245, 202, 244)",
        "rgb(255, 242, 245)",
        "rgb(255, 243, 206)",
        "rgb(222, 221, 201)",
        "rgb(255, 255, 204)",
        "rgb(235, 216, 237)",
        "rgb(207, 234, 214)",
        "rgb(244, 251, 205)",
        "rgb(250, 246, 210)",
        "rgb(248, 244, 205)",
        "rgb(228, 217, 216)",
        "rgb(224, 252, 212)",
        "rgb(203, 201, 202)",
        "rgb(201, 250, 251)",
        "rgb(229, 205, 220)",
        "rgb(208, 208, 249)",
        "rgb(226, 227, 225)",
        "rgb(236, 237, 225)",
        "rgb(249, 225, 208)",
        "rgb(249, 229, 203)",
        "rgb(214, 255, 204)",
        "rgb(247, 235, 241)",
        "rgb(224, 216, 250)",
        "rgb(251, 211, 240)",
        "rgb(210, 214, 219)",
    ];
}

export function pad(n, width, z) {
    z = z || "0";
    n = n + "";
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export function paginate(array, page_size, page_number) {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array.slice((page_number - 1) * page_size, page_number * page_size);
}

export function createGuid() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-4" +
        S4().substr(0, 3) +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
    ).toLowerCase();
}

export function sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
        currentDate = Date.now();
    } while (currentDate - date < milliseconds);
}

function isHTML(str) {
    var a = document.createElement("div");
    a.innerHTML = str;

    for (var c = a.childNodes, i = c.length; i--;) {
        if (c[i].nodeType == 1) return true;
    }

    return false;
}

export function URLReplacer(str) {
    if (isHTML(str)) {
        return str;
    }
    try {
        let match = str.match(
            /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi
        );
        let final = str;
        match.map((url) => {
            final = final.replace(
                url,
                '<a href="' + url + '" target="_BLANK">' + url + "</a>"
            );
        });
        let kd = `<p>${final}</p>`.toString();
        return kd;
    } catch (ex) {
        return str;
    }
}

export function makeId(length) {
    var result = "";
    var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }
    return result;
}

export const validateCTA = (controls, products) => {
    let errors = [];
    controls.forEach((ctrl) => {
        const name = ctrl.name;
        ;
        switch (name) {
            case "File":
                const fileInfo = JSON.parse(ctrl.value);
                if (fileInfo && IsNullOrEmpty(fileInfo.displayName)) {
                    errors.push(`<li><b>File Control :</b> Label is required</li>`);

                }
                if (fileInfo && IsNullOrEmpty(fileInfo.displayTitle)) {
                    errors.push(`<li><b>File Control :</b> Title is required</li>`);

                }
                if (fileInfo && IsNullOrEmpty(fileInfo.displayPhotoSrc)) {
                    errors.push(`<li><b>File Control :</b> File is required</li>`);

                }
                break;
            case "Timer":
                const timerInfo = JSON.parse(ctrl.value);
                if (timerInfo && IsNullOrEmpty(timerInfo.title)) {
                    errors.push(`<li><b>Countdown Control :</b> Title is required</li>`);

                }
                if (timerInfo && IsNullOrEmpty(timerInfo.description)) {
                    errors.push(`<li><b>Countdown Control :</b> Description is required</li>`);

                }
                if (timerInfo && IsNullOrEmpty(timerInfo.startTime)) {
                    errors.push(`<li><b>Countdown Control :</b> Time is required</li>`);

                }
                break;
            case "Email":
                const emailInfo = JSON.parse(ctrl.value);
                if (emailInfo && IsNullOrEmpty(emailInfo.displayLabel)) {
                    errors.push(`<li><b>Email Control :</b> Label is required</li>`);

                }
                if (emailInfo && IsNullOrEmpty(emailInfo.email)) {
                    errors.push(`<li><b>Email Control :</b> Email is required</li>`);

                }
                break;
            case "Calendar":
                const meetingInfo = JSON.parse(ctrl.value);
                if (meetingInfo && IsNullOrEmpty(meetingInfo.label)) {
                    errors.push(`<li><b>Calendar Control :</b> Label is required</li>`);

                }
                if (meetingInfo && IsNullOrEmpty(meetingInfo.subTitle)) {
                    errors.push(`<li><b>Calendar Control :</b> Title is required</li>`);

                }
                if (meetingInfo && IsNullOrEmpty(meetingInfo.meetingUrl)) {
                    errors.push(`<li><b>Calendar Control :</b> Meeting is required</li>`);

                }
                break;
            case "Payment":
                const paymentInfo = JSON.parse(ctrl.value);
                if (paymentInfo && IsNullOrEmpty(paymentInfo.title)) {
                    errors.push(`<li><b>Payment Control :</b> Label is required</li>`);

                }
                if (paymentInfo && IsNullOrEmpty(paymentInfo.subTitle)) {
                    errors.push(`<li><b>Payment Control :</b> Title is required</li>`);

                }
                if (paymentInfo && (IsNullOrEmpty(paymentInfo.amount) || parseInt(paymentInfo.amount) < 5)) {
                    errors.push(`<li><b>Payment Control :</b> Amount is required</li>`);

                }
                break;
            case "Url":
                const urlInfo = JSON.parse(ctrl.value);
                if (urlInfo && IsNullOrEmpty(urlInfo.title)) {
                    errors.push(`<li><b>Hyperlink Control :</b> Label is required</li>`);

                }
                if (urlInfo && IsNullOrEmpty(urlInfo.subTitle)) {
                    errors.push(`<li><b>Hyperlink Control :</b> Title is required</li>`);

                }
                if (urlInfo && IsNullOrEmpty(urlInfo.link)) {
                    errors.push(`<li><b>Hyperlink Control :</b> Hyperlink is required</li>`);

                }
                break;
            case "Product":
                if (products && products.length === 0) {
                    errors.push(`<li><b>Product Control :</b> Atleast one product is required</li>`);

                }
                break;
            case "Polling":
                const pollInfo = JSON.parse(ctrl.value);
                if (pollInfo && IsNullOrEmpty(pollInfo.question)) {
                    errors.push(`<li><b>Poll Control :</b> Question is required</li>`);

                }
                if (pollInfo && IsNullOrEmpty(pollInfo.subTitle)) {
                    errors.push(`<li><b>Poll Control :</b> Label is required</li>`);

                }
                if (pollInfo && pollInfo.answers && pollInfo.answers.length === 0) {
                    errors.push(`<li><b>Poll Control :</b> Answers is required</li>`);

                }
                break;
            default:
                break
        }
    });
    if (errors.length > 0) {
        Swal.fire({
            title: "Validation",
            icon: "error",
            html: `<ul class="swal-err">${errors.join("")}</ul>`
        })
    }
    return errors.length === 0;
}